import { Button, Tooltip } from "antd";
import { observer } from "mobx-react-lite";

import { useStores } from "stores";
import { ReactComponent as PlusRoundIcon } from "images/plus-round.svg";
import { AddDocumentModal } from "./AddDocumentModal";

export const AddDocumentButton = observer(() => {
  const { actionModals } = useStores();

  const addBankDetailsHandler = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    actionModals.open(() => <AddDocumentModal />, {
      width: "600px",
      noValidation: true,
      title: "Добавить документ",
      isOverlayClose: false,
      onApply: () => {
        return Promise.resolve();
      },
    });
  };
  return (
    <Tooltip title="Загрузить дополнительный документ">
      <Button type="link" size="small" icon={<PlusRoundIcon />} onClick={addBankDetailsHandler} />
    </Tooltip>
  );
});
